__turbopack_context__.v({
  "Viral": "Slider-module___0TdlG__Viral",
  "cardImg": "Slider-module___0TdlG__cardImg",
  "dramaContent": "Slider-module___0TdlG__dramaContent",
  "dramaName": "Slider-module___0TdlG__dramaName",
  "dramacontentbody": "Slider-module___0TdlG__dramacontentbody",
  "dramsHot": "Slider-module___0TdlG__dramsHot",
  "hideSaveListIcon": "Slider-module___0TdlG__hideSaveListIcon",
  "newdramaheading": "Slider-module___0TdlG__newdramaheading",
  "playbtn": "Slider-module___0TdlG__playbtn",
  "releaseBtns": "Slider-module___0TdlG__releaseBtns",
  "shine3D": "Slider-module___0TdlG__shine3D",
  "socialRelbtns": "Slider-module___0TdlG__socialRelbtns",
  "socialRelbtnsSaveList": "Slider-module___0TdlG__socialRelbtnsSaveList",
  "sway": "Slider-module___0TdlG__sway",
  "swiper": "Slider-module___0TdlG__swiper",
  "swiper-button-disabled": "Slider-module___0TdlG__swiper-button-disabled",
  "swiper-button-next": "Slider-module___0TdlG__swiper-button-next",
  "swiper-button-prev": "Slider-module___0TdlG__swiper-button-prev",
  "swiper-rtl": "Slider-module___0TdlG__swiper-rtl",
  "trendingDrama": "Slider-module___0TdlG__trendingDrama",
});
